import { API } from '../../helpers';

export const loadModelOverview = () => API.get('/api/model-management/overview');

export const saveManagedModel = (payload) =>
  API.post('/api/model-management/', payload);

export const deleteManagedModel = (name) =>
  API.delete(`/api/model-management/${encodeURIComponent(name)}`);

export const batchDeleteManagedModels = (names) =>
  API.post('/api/model-management/batch-delete', { names });

export const batchUpdateManagedModelStatus = (names, enabled) =>
  API.post('/api/model-management/batch-status', { names, enabled });

export const testManagedModelAPI = (payload) =>
  API.post('/api/model-management/test', payload);

export const getManagedModelChanges = (name) =>
  API.get(`/api/model-management/${encodeURIComponent(name)}/changes`);

export const loadVideoPricingRules = (model = '') =>
  API.get('/api/model-management/video-pricing', {
    params: model ? { model } : {},
  });

export const saveVideoPricingRule = (payload) =>
  payload.id
    ? API.put(`/api/model-management/video-pricing/${payload.id}`, payload)
    : API.post('/api/model-management/video-pricing', payload);

export const deleteVideoPricingRule = (id) =>
  API.delete(`/api/model-management/video-pricing/${id}`);
